'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'play-pause';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e22f';
var svgPathData = 'M488 64c-13.25 0-24 10.75-24 24v336c0 13.25 10.75 24 24 24S512 437.3 512 424V88C512 74.75 501.3 64 488 64zM344 64C330.7 64 320 74.75 320 88v336c0 13.25 10.75 24 24 24s24-10.75 24-24V88C368 74.75 357.3 64 344 64zM32.22 448c7.002 0 14.15-2.305 20.29-7.406l192-159.1c15.25-12.87 15.25-36.37 0-49.24L52.51 71.41C46.36 66.31 39.22 64 32.22 64C15.71 64 0 76.81 0 96.03v319.9C0 435.2 15.71 448 32.22 448zM48 130.1L199.1 256L48 381.9V130.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlayPause = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;